import {ACTION_TYPES} from "../consts";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";
import {LineupsClickEvent} from "../models/events/lineups-click-event";

export class LineupsClickEventHandler extends AnalyticsEventHandler {
  type: ACTION_TYPES = ACTION_TYPES.lineupsClick;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = LineupsClickEvent;
  }

  async action(params) {
    params.tabIndex && this.controller.action(ACTION_TYPES.onStoreGameContext, {
      game: params.game,
      tabIndex: params.tabIndex
    })

    const sportTypeId = this.state.appState.context.sportType?.id;
    const clickEvent: LineupsClickEvent = new LineupsClickEvent(params, sportTypeId);

    this.analyticsService.createEvent(clickEvent);
  }
}
